import { render } from "./EditStaffModal.vue?vue&type=template&id=6061a6bf&scoped=true"
import script from "./EditStaffModal.vue?vue&type=script&lang=js"
export * from "./EditStaffModal.vue?vue&type=script&lang=js"

import "./EditStaffModal.vue?vue&type=style&index=0&id=6061a6bf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6061a6bf"]])

export default __exports__